import { useState } from 'react'
import { PareceresListSearchComponent } from './PaceresListSearchComponent'
import { PareceresListToolbar } from './PareceresListToolbar'

export const PareceresListHeader = () => {
  // Exportar sem período destaca os campos de período como obrigatórios.
  const [forceDateRangeError, setForceDateRangeError] = useState(false)

  return (
    <div className='card-header border-0 pt-6'>
      <PareceresListSearchComponent
        forceDateRangeError={forceDateRangeError}
        actions={<PareceresListToolbar onPeriodoIncompleto={() => setForceDateRangeError(true)} />}
      />
    </div>
  )
}
